import { Flex, Form, Input } from "antd"
import React from "react"

import SelectComponent from "../../../../../components/Select"
import { placeholders } from "../../../../../constants/placeholders"
import { zipCodeRegexUS } from "../../../../../utils/validation/zip-code.ts"
import type { TeamMembersFilterOptions } from "../../../../TeamManagementPage/redux/team-members.types.ts"
import type { SettingsCompanyFormData } from "../SettingsCompanyForm.tsx"

interface CompanyInformationFormAddressProps {
  options: TeamMembersFilterOptions | null
}

export function CompanyInformationFormAddress({
  options
}: CompanyInformationFormAddressProps) {
  return (
    <Flex wrap>
      <div className={"grow basis-full"}>
        <Form.Item<SettingsCompanyFormData>
          label={"Street Address"}
          name="street_address"
        >
          <Input placeholder="Enter address" />
        </Form.Item>
      </div>

      <div className={"grow basis-40"}>
        <Form.Item<SettingsCompanyFormData> label={"City"} name="city">
          <Input placeholder="Enter city" />
        </Form.Item>
      </div>

      <div className={"grow basis-40"}>
        <Form.Item<SettingsCompanyFormData> label={"State"} name="state">
          <SelectComponent
            placeholder="Select state"
            options={options?.location}
            optionFilterType="form"
            showSearch
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input?.toLowerCase())
            }
          />
        </Form.Item>
      </div>

      <div className={"grow basis-28"}>
        <Form.Item<SettingsCompanyFormData>
          label={"ZIP Code"}
          name="zip_code"
          rules={[
            {
              required: false,
              pattern: zipCodeRegexUS,
              message: "Invalid postal code format"
            }
          ]}
        >
          <Input placeholder={placeholders.zipCode} />
        </Form.Item>
      </div>
    </Flex>
  )
}
